
















import Vue from "vue";
export default Vue.extend({
  name: "ProductCard",
  props: {
    cardTitle: String,
    cardSubtitle: String,
    cardImage: String,
  },
  data() {
    return {
      cardImageData: require("../assets/" + this.cardImage)
    }
  },
  methods: {
    cardClicked() {
      this.$emit("card-clicked")
    }
  }
})
